import React from "react";
import { BiError } from "react-icons/bi";
import { Link } from "react-router-dom";
const NotFoundPage = () => {
  return (
    <div className="h-screen w-screen bg-zinc-900 flex flex-col gap-5 justify-center items-center">
      <BiError className="text-6xl" />
      <p className="text-zinc-200 text-lg">Page not found</p>
      <Link to="/" className="text-zinc-200 text-lg">
        Home
      </Link>
    </div>
  );
};

export default NotFoundPage;
